import { makeDefaultApi } from './request';
import { I18nText } from '../i18n_text';

export interface AttributeChoiceData {
  id: string;
  code: string;
  name_json: I18nText;
}

export interface AttributeChoiceListData {
  id?: string;
  name_json: I18nText;
  choices?: AttributeChoiceData[];
}

interface AttributeChoiceListRequestParams {
  /** A serialised QtFilterModel — see `main/attribute_choice_lists/list_query.py` for the fields. */
  filter?: string;
  /** Sort keys, outermost first, `-` prefixed for descending. */
  sort?: string[];
}

export const { list, retrieve, save, remove } = makeDefaultApi<
  AttributeChoiceListData,
  AttributeChoiceListRequestParams
>('attribute_choice_lists');
